import { TableCell, TableRow, Typography } from "@mui/material";
import { BooleanInput } from "react-admin";
import { GroupKey, JBoxTypeKey, RampTestKey } from "../types";
import { JBOX_LABELS } from "../constants/tableConfig";

interface PlanningSectionHeaderProps {
  title: string;
  groupKey: GroupKey;
  rampTestKey: RampTestKey;
  existingJboxTypes: JBoxTypeKey[];
  isSoc: boolean;
  idx: number;
}

const PlanningSectionHeader = ({
  title,
  groupKey,
  rampTestKey,
  existingJboxTypes,
  isSoc,
  idx,
}: PlanningSectionHeaderProps) => {
  return (
    <>
      <TableRow>
        <TableCell size="small" align="left" colSpan={existingJboxTypes.length + 1}>
          <Typography variant="h6" fontWeight={"bold"}>
            {title}
          </Typography>
        </TableCell>
        <TableCell size="small" align="right">
          {isSoc ? (
            <BooleanInput source={`${rampTestKey}.${groupKey}.active`} label="Actif" shouldUnregister={false} />
          ) : (
            // render the single AFRR toggle only on the FIRST AFRR section
            idx === 1 && (
              <BooleanInput
                source={`${rampTestKey}.afrr_active`}
                label="AFRR phases actives"
                shouldUnregister={false}
              />
            )
          )}
        </TableCell>
      </TableRow>

      {/* JBox columns header */}
      <TableRow sx={{ "& .MuiTableCell-root": { fontWeight: "bold", fontSize: "1.1rem" } }}>
        <TableCell size="small" />
        {existingJboxTypes.map((jbox) => (
          <TableCell key={jbox} size="small" align="center">
            {JBOX_LABELS[jbox]}
          </TableCell>
        ))}
        <TableCell />
      </TableRow>
    </>
  );
};

export default PlanningSectionHeader;
